exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.buttonsDiv[data-v-570f8ad6] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.buttonActions[data-v-570f8ad6] {\n  margin: 25px 0 0 20px;\n}\n", ""]);

